import { app } from '../../../bootstrap/core';
import { TicketsChartService } from './chart.service';

app.service('ticketsChartService', TicketsChartService);
